import { useEffect, useRef } from "react";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";

export default function AboutUs() {
    const aboutSection = useRef(null);

    useEffect(() => {
        if (aboutSection.current) {
            aboutSection.current.scrollIntoView({ behavior: "auto" });
        }
    }, []);


    return (
        <>
            <div className="max-lg:px-5 lg:px-5 py-4">
                <HelmetComponent
                    title="About Us - Shri Radhe Holidays | Trusted Travel Agency"
                    description="Learn about Shri Radhe Holidays, a trusted travel agency offering domestic and international holiday packages, honeymoon tours, flights, hotels, visa assistance and customized vacations."
                    url="https://www.shriradheholidays.com/about"
                />

                <div className={`wow fadeInUp  scroll-mt-[90px]`}
                    data-wow-delay="1ms"
                    ref={aboutSection}
                >
                    <h1 className="  playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white  text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                        style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                    >
                        About Us
                    </h1>
                    <div className="" ref={aboutSection}>
                        <p className="mb-4 mt-4 text-gray-700 leading-relaxed text-start ">
                            <p className="text-lg poppins
                            ">
                                <span className="text-[#D4AF37] font-bold text-lg">
                                    Shri Radhe Holidays
                                </span>
                                <span className="font-semibold mx-2">
                                    was founded in 2025 by Mr. Hardev Singh and Mr. Vishal Singh.
                                </span>
                                With a deep passion for travel and a vision to provide seamless travel experiences, our mission is to make travel accessible, enjoyable, and stress-free for everyone. Whether it is a family vacation, a corporate tour, or a romantic getaway, we are committed to curating the perfect travel experience for our customers.
                            </p>
                        </p>
                        <p className="mb-4 text-gray-700 leading-relaxed text-start text-lg poppins">
                            we believe that every journey is a story waiting to be written. Founded with a passion for travel and exploration, we are dedicated to crafting unforgettable travel experiences for our customers. Whether you're looking for a serene escape, a family adventure, or a romantic getaway, our team is committed to turning your travel dreams into reality.
                        </p>
                        <p className="mb-4 text-gray-700 leading-relaxed text-justify text-lg poppins">
                            From flights and hotels to visas and guided experiences, we handle everything so you can focus on enjoying your journey.
                        </p>

                        <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Why Choose Us?</h3>
                        <ol className="poppins" style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "number" }}>
                            <li className="hanuman-bold" style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                                Personalized Travel Solutions:
                                <span className="poppins" style={{ fontWeight: "normal", textAlign: "start", display: "block" }}>
                                    Every traveler is unique, and so are our packages. We tailor each journey to suit your preferences,
                                    budget, and interests, ensuring a memorable experience.
                                </span>
                            </li>
                            <li className="hanuman-bold" style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                                Affordable Luxury:
                                <span className="poppins" style={{ fontWeight: "normal", textAlign: "start", display: "block" }}>
                                    Experience premium accommodations, hand-picked activities, and top-tier services, all at competitive
                                    prices that make luxury travel affordable.
                                </span>
                            </li>
                            <li className="hanuman-bold" style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                                Global Reach:
                                <span className="poppins" style={{ fontWeight: "normal", textAlign: "start", display: "block" }}>
                                    From exploring the deserts of Dubai to soaking in the beaches of Bali, our packages cover both
                                    domestic and international destinations, offering you a wide range of travel options.
                                </span>
                            </li>
                            <li className="hanuman-bold" style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                                Seamless Travel Planning:
                                <span className="poppins" style={{ fontWeight: "normal", textAlign: "start", display: "block" }}>
                                    We handle everything from flight bookings and hotel reservations to visa assistance and guided tours,
                                    so you can focus on enjoying your journey without any worries.
                                </span>
                            </li>
                            <li className="hanuman-bold" style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                                Expert Team:
                                <span className="poppins" style={{ fontWeight: "normal", textAlign: "start", display: "block" }}>
                                    Our dedicated travel experts have years of experience in curating exceptional holidays, ensuring
                                    that your trip is well-planned and stress-free.
                                </span>
                            </li>
                        </ol>

                        <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Our Mission</h3>
                        <p className="poppins mb-4">
                            To create extraordinary travel experiences that inspire, connect, and bring joy to travelers worldwide.
                            We aim to be a trusted travel partner, ensuring every journey is filled with comfort, adventure, and
                            cherished memories.
                        </p>

                        <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Our Vision</h3>
                        <p className="poppins mb-4">
                            To establish Shri Radhe Holidays as a leading name in the travel industry, known for trust, innovation,
                            and excellence in delivering unparalleled travel experiences.
                        </p>

                        <h3 className="h4 mb-3 font-bold playfair-display">Our Services</h3>
                        <div className="mb-6 space-y-1 poppins">
                            <p className="mb-0">• Flight, Hotel, Bus & Cab Bookings</p>
                            <p className="mb-0">• Customized Holiday Packages</p>
                            <p className="mb-0">• Group Tours & Honeymoon Trips</p>
                            <p className="mb-0">• Corporate Travel Solutions</p>
                            <p className="mb-0">• Visa Assistance & Travel Insurance</p>
                            <p className="mb-0">• Forex Exchange Services</p>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollToTop />
        </>
    )
}
